<template>
  <div class="row">
    <a-row>
      <a-card title="我的订单">
        <a-table :columns="columns" :data-source="trades" :scroll="{x: true}" rowKey="trade_id">
          <span slot="product_data" slot-scope="text, record">
            <span v-if="record.type === 'goods'">
              <span v-if="record.product_data.length > 1">
                <p v-for="goods in record.product_data" :key="goods.plan.plan_id" v-if="record.type === 'goods'">
                  <span>{{ goods.plan.name }} （{{ goods.service.name }}） x {{ goods.qty }}</span>
                </p>
              </span>
              <span v-else>{{ record.product_data[0].plan.name }} （{{ record.product_data[0].service.name }}） x {{ record.product_data[0].qty }}</span>
            </span>
            <span v-else-if="record.type === 'service'">{{ record.product_data[0].service.name }}</span>
          </span>
          <span slot="status" slot-scope="text, record">
            <a-tag color="green" v-if="record.status === 1">{{ record.status | tradeStatusFilter }}</a-tag>
            <a-tag color="orange" v-else-if="record.status === 2">{{ record.status | tradeStatusFilter }}</a-tag>
            <a-tag color="orange" v-else-if="record.status === 10">{{ record.status | tradeStatusFilter }}</a-tag>
            <a-tag color="green" v-else-if="record.status === 20">{{ record.status | tradeStatusFilter }}</a-tag>
          </span>
          <span slot="price" slot-scope="text, record">
            ￥{{ record.price | number('0,0.00')}}元
          </span>
          <span slot="action" slot-scope="text, record">
            <a-button type="primary" @click="showDetail(record)" icon="eye">查看</a-button>
          </span>
        </a-table>
      </a-card>
    </a-row>
  </div>
</template>

<script>
import { baseMixin } from '@/libs/app-mixin'
import { getTradeList } from '@/api/trade'

export default {
  name: 'Trades',
  mixins: [baseMixin],
  data () {
    return {
      trades: [],
      columns: [
        {
          title: '订单号',
          width: 200,
          dataIndex: 'trade_no',
          key: 'trade_no'
        },
        {
          title: '订单信息',
          width: 350,
          scopedSlots: { customRender: 'product_data' }
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '金额',
          width: 150,
          scopedSlots: { customRender: 'price' }
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    getTradeList (status) {
      getTradeList({
        status: status,
        page: 1,
        pageSize: 30
      }).then(res => {
        this.trades = res.result.list
        this.tradeTotal = res.result.total
      })
    },
    showDetail (trade) {
      console.log(trade)
      location.href = '/#/my/trade/' + trade.trade_id
    }
  },
  mounted () {
    this.getTradeList([1, 2, 10, 20])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/My/Trades.vue